import { withAuthSync } from 'components/common/withAuthSync/withAuthSync';
import Home from './Home';
export default withAuthSync(Home);